<template>
  <div class="page-wrapper fullheight">
    <PageMenu />
    <Content class="page-content-wrapper">
      <router-view />
    </Content>
  </div>
</template>

<script>
import PageMenu from '@/components/layouts/PageMenu'

export default {
  components: {
    PageMenu
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  .page-content-wrapper {
    overflow: auto;
    height: calc(100% - 60px);
  }
}
</style>
